import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

const requestedUserInfo = createAction("updateUserInfo/requested")
const receivedUserInfo = createAction("updateUserInfo/received")
const failedUserInfo = createAction("updateUserInfo/failed")
const cleanedUserInfo = createAction("updateUserInfo/cleaned")

const initialState = {
    userInfo: {
      ...LOADING_INITIAL_STATE,
      data: {}
    }
}

const updateEmailPhoneReducer = createReducer(initialState, {
  [requestedUserInfo.type]: (state) => {
    setRequested(state.userInfo)
  },
  [receivedUserInfo.type]: (state, action) => {
    setReceived(state.userInfo)
    state.userInfo.data = action.payload
  },
  [failedUserInfo.type]: (state) => {
    setFailed(state.userInfo)
  },
  [cleanedUserInfo.type]: (state) => {
    state.userInfo = initialState.userInfo
  },
})

export default updateEmailPhoneReducer


export const updateUserInfo = (data) =>
    api({
      url: `user/update_user_info`,
      method: "put",
      onStart: requestedUserInfo.type,
      onSuccess: receivedUserInfo.type,
      onError: failedUserInfo.type,
      data
    })


// export const cleanedUpdateEmailPassword = () => (dispatch) => dispatch(cleaned())